// extracted by mini-css-extract-plugin
export default {"Tag":"styles_Tag__Kqf5e"};